import sdl from '@jds/react-generated-sdl/JDSIcon';
import type { JDSIconProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, IconProps } from '../logic';

const Component = (props: IconProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    size = 'medium',
    color = 'primary_50',
    kind = 'default',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { size, color, kind, ...rest },
    'JDSIcon',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Icon = withLogic(Component) as React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<HTMLDivElement>
> & { slotName?: string };

Icon.displayName = 'Icon';
Icon.slotName = 'jds_icon';

export { Icon, type JDSIconProps };
